"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTransaction = exports.fetchTransfers = void 0;
var fetchTransfers = function (setState, state, options, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var INDEXER_URL, clearedParams, params, response, responseParsed, transfers, pageInfo, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                INDEXER_URL = window.__RUNTIME_CONFIG__.INDEXER_URL;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                setState(__assign(__assign({}, state), { isLoading: true }));
                clearedParams = Object.entries(__assign(__assign({}, options), filters)).filter(function (_a) {
                    var _b = __read(_a, 2), k = _b[0], v = _b[1];
                    return v !== undefined && v !== "";
                });
                params = new URLSearchParams(clearedParams).toString();
                return [4 /*yield*/, fetch("".concat(INDEXER_URL, "/transfers/filters?").concat(params))];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                responseParsed = _a.sent();
                transfers = responseParsed.transfers;
                pageInfo = responseParsed.pageInfo;
                setState(__assign(__assign({}, state), { isLoading: false, transfers: transfers, pageInfo: pageInfo }));
                return [3 /*break*/, 5];
            case 4:
                error_1 = _a.sent();
                console.log("ERROR", error_1);
                setState(__assign(__assign({}, state), { error: true, isLoading: false }));
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.fetchTransfers = fetchTransfers;
var fetchTransaction = function (txHash, setState) { return __awaiter(void 0, void 0, void 0, function () {
    var INDEXER_URL, response, responseParsed, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                INDEXER_URL = window.__RUNTIME_CONFIG__.INDEXER_URL;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch("".concat(INDEXER_URL, "/transfers/byTransactionHash/").concat(txHash))];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                responseParsed = _a.sent();
                setState(responseParsed);
                return [3 /*break*/, 5];
            case 4:
                error_2 = _a.sent();
                console.error("Error getting one transaction", error_2);
                return [2 /*return*/, error_2];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.fetchTransaction = fetchTransaction;
//# sourceMappingURL=ExplorerService.js.map